<template>
  <div>
    <div class="columns dontprint">
      <div class="column is-1">
        <h1 class="title is-5">Cartera</h1>
      </div>
      <div class="column is-4">
        <div class="control">
          <div class="select">
            <select v-model="cuentaselected" @change="updateempresa">
              <option
                v-for="(item, index) in options"
                :key="index"
                :value="item._id"
              >
                {{ item.codigo }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="control">
          <div class="field has-addons">
            <div class="control">
              <a class="button is-info" @click="launchModal">
                <span class="icon is-small">
                  <span class="material-icons"> search </span>
                </span>
              </a>
            </div>
            <div class="control">
              <input
                id="cl1"
                class="input"
                v-model="clientedescripcion"
                type="text"
                placeholder="Tercero"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <input
          v-model="tolerancia"
          class="input"
          type="number"
          placeholder="Tolerancia"
        />
      </div>
      <div class="column is-4">
        <div class="buttons has-addons is-right">
          <button class="button is-link" @click="findCartera">Buscar</button>
          <button class="button is-primary" @click="downcartera">
            Descargar
          </button>
          <button class="button is-light" @click="print">Imprimir</button>
        </div>
      </div>
    </div>
    <div class="columns printed">
      <div class="column">
        <h1 class="title is-4">
          {{ empresa.nombre }}
          <small class="has-text-grey"
            >{{ empresa.nit | textnumber() }}{{ empresa.nit | dverif() }}</small
          >
        </h1>
        <h2 class="subtitle">
          Informe de Cartera al {{ dateNow | dateletra() }}
        </h2>
      </div>
    </div>
    <table class="table is-narrow is-fullwidth">
      <thead>
        <tr>
          <th>Tercero</th>
          <th>Saldo</th>
          <th>Días</th>
          <th>Fecha</th>
          <th>Vencimiento</th>
          <th>Plazo</th>
        </tr>
      </thead>
      <tbody v-for="(item, index) in cartera.rercerostolerancia" :key="index">
        <tr>
          <td class="fontMono">
            <strong
              >{{
                nitsfilter[item] ? nitsfilter[item].codigo : "" | textnumber()
              }}
              - {{ nitsfilter[item] ? nitsfilter[item].nombre : "" }}</strong
            >
          </td>

          <td class="fontMono has-text-right"></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr v-for="(item1, index1) in cartera[item].list" :key="index1">
          <td class="fontMono has-text-right">
            <strong>{{ item1._id.docRef }}</strong>
          </td>
          <td class="fontMono has-text-right">{{ item1.valor | number() }}</td>
          <td class="fontMono has-text-right">
            {{ item1.fecha | number() }}
          </td>
          <td class="fontMono">
            <small>{{ item1.fecha1 | dateletra() }}</small>
          </td>
          <td class="fontMono">
            <small>{{ item1.fpago1 | dateletra() }}</small>
          </td>
          <td class="fontMono has-text-right">
            <small>{{ item1.fpago }}</small>
          </td>
        </tr>
        <tr style="background-color: #f5f5f5">
          <td>
            <strong class="has-text-link"
              >Total
              <small
                >{{
                  nitsfilter[item] ? nitsfilter[item].codigo : "" | textnumber()
                }}
                - {{ nitsfilter[item] ? nitsfilter[item].nombre : "" }}</small
              >
            </strong>
          </td>
          <td class="fontMono has-text-right">
            <strong class="has-text-link">{{
              cartera[item].saldo | number()
            }}</strong>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr class="has-background-white">
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td class="has-text-white dontprint">0</td>
        </tr>
      </tbody>
      <tbody>
        <tr style="background-color: #3273dc">
          <td><strong class="has-text-white">Total</strong></td>
          <td class="fontMono has-text-right">
            <strong class="has-text-white">{{
              cartera.total | number()
            }}</strong>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";
import { mapState } from "vuex";
export default {
  data() {
    return {
      cartera: {
        terceros: [],
        rercerostolerancia: [],
        total: 0,
      },
      options: [],
      cuentaselected: null,
      clientedescripcion: null,
      clienteid: null,
      tolerancia: 100,
      nitsfilter: {},
    };
  },
  computed: {
    ...mapState(["cuentas", "resultDatamodal", "nits", "empresa", "isOculto"]),
    dateNow() {
      return new Date();
    },
  },
  methods: {
    async downcartera() {
      try {
        let idcliente = false;
        if (this.cuentaselected) {
          if (this.clientedescripcion) {
            idcliente = this.clienteid;
          }
          const result = await apiServices.post(
            `/downcartera`,
            {
              idcuenta: this.cuentaselected,
              idcliente,
              tolerancia: this.tolerancia,
            },
            { responseType: "blob" }
          );
          if (result.data) {
            const url = window.URL.createObjectURL(new Blob([result.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(`download`, `Cartera.xlsx`); // or any other extension
            document.body.appendChild(link);
            link.click();
          }
        } else {
          this.$store.dispatch("notify", {
            message: "Debe seleccionar una cuenta",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
      } catch (e) {
        console.log(e);
      }
    },
    print() {
      const _this = this;
      if (this.isOculto) {
        this.$store.commit("ocultarSide");
        setTimeout(() => {
          window.print();
          _this.$store.commit("ocultarSide");
        }, 200);
      } else {
        window.print();
      }
    },
    async updateempresa() {
      try {
        const empresa = JSON.parse(JSON.stringify(this.empresa));
        empresa.cuentacartera = this.cuentaselected;
        const result = await apiServices.post(`/editempresa`, empresa);
        if (result.data) {
          this.$store.commit("refreshEmpresa", result.data);
        }
      } catch (err) {
        console.log(err);
      }
    },
    sumarDias(fecha, dias) {
      if (fecha === 0) {
        return 0;
      } else {
        let fecha1 = new Date(fecha);
        fecha1.setDate(fecha1.getDate() + dias);
        return fecha1;
      }
    },
    calculatedays(d) {
      let diff;
      if (d !== 0) {
        let dt1 = new Date().getTime();
        let dt = new Date(d).getTime();
        diff = dt1 - dt;
        diff = diff / (1000 * 60 * 60 * 24);
      } else {
        diff = 0;
      }
      return parseInt(diff);
    },
    launchModal() {
      const datanits = this.nits.map((e) => {
        const d = {
          codigo: e.codigo,
          nombre: e.nombre,
          id: e._id,
          selected: false,
        };
        return d;
      });
      this.$store.commit("launchModal", {
        title: "Seleccione el Cliente",
        oktext: "Aceptar",
        canceltext: "Cancelar",
        titleTable: [
          { cod: "codigo", name: "Código" },
          { cod: "nombre", name: "Nombre" },
        ],
        table: datanits,
        result: "cl1",
      });
    },
    addnittodata(data) {
      const _this = this;
      let returned = JSON.parse(JSON.stringify(data));
      for (let index in returned.rercerostolerancia) {
        const tercero = returned.rercerostolerancia[index];
        _this.nitsfilter[tercero] = this.nits.filter(
          (nit) => nit._id === tercero
        )[0];
        for (let index1 in returned[tercero].list) {
          const datatercero = returned[tercero].list[index1];
          const fecha = JSON.parse(JSON.stringify(datatercero.fecha));
          returned[tercero].list[index1].fecha = _this.calculatedays(
            datatercero.fecha
          );
          returned[tercero].list[index1].fecha1 = fecha;
          returned[tercero].list[index1].fpago1 = _this.sumarDias(
            fecha,
            datatercero.fpago
          );
        }
        returned[tercero].list.sort(
          (a, b) => parseInt(b.fecha) - parseInt(a.fecha)
        );
      }
      return returned;
    },
    async findCartera() {
      try {
        let idcliente = false;
        if (this.cuentaselected) {
          if (this.clientedescripcion) {
            idcliente = this.clienteid;
          }
          const result = await apiServices.post(`/cartera`, {
            idcuenta: this.cuentaselected,
            idcliente,
            tolerancia: this.tolerancia,
          });
          if (result.data) {
            this.cartera = this.addnittodata(result.data);
          }
        } else {
          this.$store.dispatch("notify", {
            message: "Debe seleccionar una cuenta",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
      } catch (err) {
        console.log(err);
      }
    },
    sortAccounts() {
      const _this = this;
      this.options.push({
        _id: null,
        codigo: "Seleccionar cuenta",
      });
      for (let index in this.cuentas) {
        const cuenta = _this.cuentas[index];
        const grupo = cuenta.codigo.substring(0, 2);
        const option = {
          _id: null,
          codigo: "",
        };
        if (cuenta.esRegistro && grupo === "13") {
          option._id = cuenta._id;
          option.codigo = `${cuenta.codigo} - ${cuenta.nombre}`;
          _this.options.push(option);
        }
      }
    },
  },
  watch: {
    resultDatamodal(newv, oldv) {
      if (newv.result === "cl1") {
        this.clientedescripcion = `${newv.data.codigo} - ${newv.data.nombre}`;
        this.clienteid = newv.data.id;
        document.getElementById("cl1").focus();
      }
    },
  },
  created() {
    this.sortAccounts();
    if (this.empresa.cuentacartera) {
      this.cuentaselected = this.empresa.cuentacartera;
    }
  },
};
</script>

<style lang="scss" scoped>
@media print {
  .dontprint {
    display: none !important;
  }
  .printed {
    display: block !important;
  }
}
.printed {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/comisiones/Cartera.vue